export default __webpack_public_path__ + "static/media/customer-feedback-survey.9067f0c3.png";